import { AudienceCondition } from '../../components/groups/audience-selector';
import { GroupType } from '../../schemas/groups';

export enum QuestionType {
	Text = 'text',
	Radio = 'radio',
	Checkbox = 'checkbox',
	Dropdown = 'dropdown',
}

export type NominationQuestion = {
	/** Stable BSON ObjectId from the server. Present when the question was loaded from the API; absent for newly-added questions in the form. */
	id?: string;
	questionText: string;
	questionType: QuestionType;
	options: string[];
	isRequired: boolean;
};

/** Builds the default first question with a translated `questionText`. */
export const buildDefaultFirstQuestion = (questionText: string): NominationQuestion => ({
	questionText,
	questionType: QuestionType.Text,
	options: [],
	isRequired: true,
});

export const EMPTY_QUESTION: NominationQuestion = {
	questionText: '',
	questionType: QuestionType.Text,
	options: [],
	isRequired: false,
};

export const MAX_QUESTIONS = 5;

export type NominationPeriodFormData = {
	name: string;
	description: string;
	startDate: Date | null;
	endDate: Date | null;
	nominationLimit: number | null;
	nomineeConditions: AudienceCondition[];
	nomineeConditionsOperator: GroupType;
	nominatorConditions: AudienceCondition[];
	nominatorConditionsOperator: GroupType;
	questions: NominationQuestion[];
};
